import { render } from "./CreateFilesystemModal.vue?vue&type=template&id=0824a517"
import script from "./CreateFilesystemModal.vue?vue&type=script&lang=js"
export * from "./CreateFilesystemModal.vue?vue&type=script&lang=js"

import "./CreateFilesystemModal.vue?vue&type=style&index=0&id=0824a517&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QInput});
